var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Company ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/company/sub-visual-company.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "회사소개",
      "tabActive": 4
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--contact"
  }, [_c('v-container', [_c('v-card', {
    staticClass: "h-300px h-lg-500px",
    attrs: {
      "flat": ""
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.1213528284475!2d127.22307098860779!3d37.52863656001022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cb23ba131d1cf%3A0x426f880eb3cef2dd!2z6rK96riw64-EIO2VmOuCqOyLnCDssL3smrDroZwgMzgtMzU!5e0!3m2!1sko!2skr!4v1687430444070!5m2!1sko!2skr",
      "width": "100%",
      "height": "100%",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('div', {
    staticClass: "mt-30 mt-md-44 mt-md-60"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "list-wrap border-xl-end",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-img', {
    staticClass: "mr-24",
    attrs: {
      "min-width": "40",
      "max-width": "48",
      "aspect-ratio": "1/1",
      "contain": "",
      "src": "/images/sub/company/contact/address.png"
    }
  }), _c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" Address ")])]), _c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v(" 경기도 하남시 창우로 38-35번지 ")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "list-wrap list-wrap--center border-xl-end",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "mr-24",
    attrs: {
      "min-width": "40",
      "max-width": "48",
      "aspect-ratio": "1/1",
      "contain": "",
      "src": "/images/sub/company/contact/tel.png"
    }
  }), _c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" Tel ")])]), _c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v(" 02-487-7350 ")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "list-wrap list-wrap--center border-xl-end",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-img', {
    staticClass: "mr-24",
    attrs: {
      "min-width": "40",
      "max-width": "48",
      "aspect-ratio": "1/1",
      "contain": "",
      "src": "/images/sub/company/contact/fax.png"
    }
  }), _c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" Fax ")])]), _c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v(" 02-486-2189 ")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "list-wrap list-wrap--end",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('v-img', {
    staticClass: "mr-24",
    attrs: {
      "min-width": "40",
      "max-width": "48",
      "aspect-ratio": "1/1",
      "contain": "",
      "src": "/images/sub/company/contact/e-mail.png"
    }
  }), _c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" E-mail ")])]), _c('p', {
    staticClass: "page-text grey--text"
  }, [_vm._v(" MODOO456@naver.com ")])])], 1)])], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }